import { useCallback, useState } from 'react';
import api from '@app/network/apiClient';
import { log } from '../../utils';
import { AxiosResponse } from 'axios';

interface LoadDataResult<T = Record<string, unknown>> {
  data: T;
  response: AxiosResponse | null;
  error: boolean;
}

interface LoadDataHook<T> {
  loadData: (url: string) => Promise<LoadDataResult<T>>;
  loading: boolean;
  error: boolean;
}

const useLoadData: <T>(loadingOnInit?: boolean) => LoadDataHook<T> = (
  loadingOnInit = true
) => {
  const [loading, setLoading] = useState(loadingOnInit);
  const [error, setError] = useState(false);

  const loadData = useCallback(
    (url: string) => {
      let rawResponse: AxiosResponse | null = null;
      setLoading(true);

      return api(url)
        .then((response) => {
          if (response.status >= 400) {
            setError(true);
          }
          rawResponse = response;
          return response.data.data;
        })
        .catch((err) => {
          log('error', err);
          setError(true);
          return [];
        })
        .then((data) => {
          setLoading(false);
          return {
            data,
            response: rawResponse,
            error: error,
          };
        });
    },
    [error]
  );

  return {
    loadData,
    loading,
    error,
  };
};

export default useLoadData;
